import { ResumenByClienteProductoUsuario } from "../../bussines/entities/EstadisticasLlave.entity";

export class ResumenByClienteProductoUsuarioModel implements ResumenByClienteProductoUsuario {
    constructor(
        public ruc: string,
        public razonsocial: string,
        public producto: string,
        public usuario: string,
        public mes: number,
        public value: number
    ) { }

    serialize(): ResumenByClienteProductoUsuario {
        return {
            ruc: this.ruc,
            razonsocial: this.razonsocial,
            producto: this.producto,
            usuario: this.usuario,
            mes: this.mes,
            value: this.value
        }
    }

    static deserialize(entity: ResumenByClienteProductoUsuario): ResumenByClienteProductoUsuarioModel {
        return new ResumenByClienteProductoUsuarioModel(
            entity.ruc ?? '',
            entity.razonsocial ?? '',
            entity.producto ?? '',
            entity.usuario ?? '',
            entity.mes ?? 0,
            entity.value ?? 0
        );
    }
}